<template lang="pug">
.d-flex.i_mt_8
  img(:src="resource.image")
  .content.i_pl_4
    h5 {{ resource.title }}
    p.i_body_l {{ resource.content }}
</template>

<script>
export default {
  name: "Resource",
  props: {
    resource: Object,
  },
};
</script>

<style lang="scss" scoped>
img {
  @include size(115px, 150px);
  flex-shrink: 0;
}

h2.title {
  @include font(36px, $color_blue_ci, normal);
}

h5 {
  @include font(20px, $color_black_text, normal);
}

@media (max-width: 991px) {
  img {
    @include size(92px, 120px);
  }

  h2.title {
    font-size: 24px;
  }

  h5 {
    font-size: 16px;
  }
}

@media (max-width: 767px) {
  .container {
    max-width: 100%;
  }

  h2.title {
    font-size: 24px;
  }

  h5 {
    font-size: 24px;
  }
}

@media (max-width: 575px) {
  img {
    @include size(16vw, 20vw);
  }

  h2.title {
    font-size: 5.2vw;
  }

  h5 {
    font-size: 3.5vw;
  }

  p.i_body_l {
    font-size: 3.5vw;
    line-height: 7.35vw;
  }
}
</style>
